export default __webpack_public_path__ + "static/media/doctorbg.9f7ba6a6.jpg";